import { useEffect } from 'react'
import styled from 'styled-components'
import TableView, { ColumnConfig } from '../../components/controls/table-view'
import { useAppSelector } from '../../hooks/useAppSelector';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { fetchApprovalOrders, resetApprovals, setSelectedDepartment } from '../../store/features/ordering/approval/approval-slice';
import Button from '../../components/controls/button';
import { TableContainer } from '../../styles/shared/table';
import { setCurrentPage } from '../../store/features/authentication/user-slice';
import { useNavigate } from 'react-router-dom';
import { fetchBranches } from '../../store/features/organisation/branch-slice';
import { ApplicationDepartment } from '../../models/organisation/application-department';
import { fetchDepartments } from '../../store/features/organisation/department-slice';
import AdminSidebar from '../../components/layout/admin-sidebar';

export default function AdminApprovals() {
    const approval = useAppSelector(state => state.approval);
    const branches = useAppSelector(state => state.branch).branches;
    const departments = useAppSelector((state) => state.department);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const fetchMoreData = async () => {
        if (approval.selectedDepartment?.id) {
            await dispatch(fetchApprovalOrders({ departmentId: approval.selectedDepartment?.id }))
        }
    }

    const handleDepartmentSelect = async (department: ApplicationDepartment) => {
        dispatch(setSelectedDepartment(department));
        if (approval.selectedDepartment?.id !== department.id) {
            await dispatch(fetchApprovalOrders({
                departmentId: department.id,
                fetchParams: {
                    reset: true
                }
            }))
        }
    };


    useEffect(() => {
        dispatch(fetchBranches());
        dispatch(fetchDepartments()).then((action) => {
            if (
                fetchDepartments.fulfilled.match(action) &&
                action.payload.departments &&
                action.payload.departments.length > 0
                && approval.selectedDepartment == null
            ) {
                const firstDepartment = action.payload.departments[0];
                if (firstDepartment) {
                    handleDepartmentSelect(firstDepartment);
                }
            }
        });
        dispatch(setCurrentPage("Approvals"))

        return () => {
            dispatch(resetApprovals())
        }
    }, [dispatch]);

    const columnConfig: { [key: string]: ColumnConfig } = {
        id: {
            hidden: true,
        },
        displayName: {
            order: 1,
            name: "Order",
            colspan: 2,
            render: (value: string) => (
                <div>
                    <strong>{value}</strong>
                </div>
            ),
        },
        subDepartmentName: {
            order: 2,
            name: "Sub Department",
            colspan: 2,
            render: (value: string) => (
                <div>
                    <strong>{value}</strong>
                </div>
            ),
        },
        status: {
            hidden: true,
        },
        lineCount: {
            name: "Items",
            hideOnMobile: true,
            order: 2,
            render: (value: number) => <div>{value} products</div>,
        },
        branchId: {
            name: "Branch",
            order: 4,
            render: (value: number) => (
                <div>
                    {branches?.find(x => x.id == value)?.name}
                </div>
            )
        },
        created: {
            hideOnMobile: true,
            name: "Order date",
            render: (value: Date) => (
                <div>
                    {new Date(value).toLocaleString("en-gb", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    })}
                </div>
            ),
        },
    };


    const renderFilterBar = () => (
        <div>
         
        </div>
    );

    const renderActionButton = (row: any) => (
        <Button variant="outlined" id={row.Name}
            onClick={() => navigate(`/admin/approvals/${row.branchId}/${row.id}`)}
            label='View Order' isPrimary={true} fullWidth={false} />
    );

    return (
        <ApprovalContainer>
            <NavigationSection>
                <AdminSidebar
                    items={(departments.departments?.departments ?? []).map((department) => ({
                        label: department.name,
                        action: () => handleDepartmentSelect(department),
                        isSelected: department.id == approval.selectedDepartment?.id
                    }))}
                ></AdminSidebar>
            </NavigationSection>
            <ContentSection>
                <TableContainer>
                    <TableView
                        id="ordersTable"
                        emptyText='No approvals '
                        filterBar={renderFilterBar}
                        fetchData={fetchMoreData}
                        totalCount={approval.approvalOrders?.count ?? 0}
                        data={approval?.approvalOrders?.orders ?? []}
                        columnConfig={columnConfig}
                        actionButton={renderActionButton}
                        showHeaders={true}
                    />
                </TableContainer>
            </ContentSection>
        </ApprovalContainer>
    )
}

const ApprovalContainer = styled.div`
     display: flex;
  margin: 10px;
  column-gap: 20px;
  height: 100%;
  @media (max-width: 1600px) {
    flex-direction: column;
  }
    
`

const NavigationSection = styled.div`
  min-width: 15%;
`;

const ContentSection = styled.div`
width:100%;
`;